import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  RadioGroupProps,
  Typography,
  SxProps, 
  Theme 
} from "@mui/material";
import * as React from "react";
import { useLanguage } from "./Language";
export interface AudienceFilterProps extends RadioGroupProps {
  sx?: SxProps<Theme>;
}
export const AudienceFilter: React.FC<AudienceFilterProps> = ({sx, value, onChange, ...props}) => {
  const { translate } = useLanguage();

  return (
    <FormControl
      sx={{
        ...sx
      }}
    >
      <RadioGroup
        aria-label="Audience Filter"
        name="audience-filter"
        {...props}
        value={value}
        onChange={onChange}
      >
        <FormControlLabel
          value=""
          control={<Radio />}
          label={translate("audienceAll")}
        />
        <FormControlLabel
          value="Adult / General"
          control={<Radio />}
          label={translate("audienceAdult")}
        />
        <FormControlLabel
          value="Juvenile"
          control={<Radio />}
          label={translate("audienceJuvenile")}
        />
      </RadioGroup>
    </FormControl>
  );

};